export default [
  'Join now and set your hourly rate.',
  'Create your own unique profile.',
  'Receive relevant industry consulting opportunities.',
  'Get paid and connect with other professionals!',
];